/**
 * TanStack Query hooks for `link-test-tool`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	linkTestToolQueryKeys,
	type CreateLinkTestToolBody,
	type ListLinkTestToolResponse,
	type LinkTestToolRow,
} from "./api";

export function useLinkTestToolList(): UseQueryResult<ListLinkTestToolResponse, Error> {
	return useQuery({
		queryKey: linkTestToolQueryKeys.list(),
		queryFn: list,
	});
}

export function useLinkTestToolCreate(): UseMutationResult<LinkTestToolRow, Error, CreateLinkTestToolBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkTestToolQueryKeys.all });
		},
	});
}

export function useLinkTestToolDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: linkTestToolQueryKeys.all });
		},
	});
}
